import { createFileRoute } from "@tanstack/react-router";
import { Investments } from "@/components/Investments";

function RouteComponent() {
  return <Investments />;
}

export const Route = createFileRoute("/_authenticated/investments/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
